/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Center_Errors_HintInputs */



/**
* | output |
* | --- |
* | "Errors shown in this browser tab. They are cleared when you sign out." |
*
* @param {Activity_Center_Errors_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const activity_center_errors_hint = /** @type {((inputs?: Activity_Center_Errors_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Center_Errors_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler, die in diesem Browser-Tab angezeigt wurden. Sie werden beim Abmelden gelöscht.")
	return /** @type {LocalizedString} */ ("Errors shown in this browser tab. They are cleared when you sign out.")
});